module.exports = __webpack_public_path__ + "static/tech-Icon-quick-roll-f16ea944855732f7f1ae016163ec2791.png";